<template>
  <button
    type="button"
    class="fpds-Button"
    :class="buttonClass"
    :disabled="disabled"
    @click="onClick"
  >
    <template><slot>Caption</slot></template>
    <template v-if="loading">
      <div class="fpds-Button-iconEnd">
        <div class="fpds-ProgressSpinner fpds-ProgressSpinner--small"></div>
      </div>
    </template>
  </button>
</template>
<script>
export default {
  name: "ActionButton",
  props: {
    loading: Boolean,
    buttonType: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    leftPad: { type: Boolean, default: false },
    onClick: {
      type: Function,
      required: true,
    },
  },
  computed: {
    buttonClass: function () {
      let css = "fpds-Button--" + (this.buttonType ?? "default");
      if (this.leftPad) {
        css += " u-marginLeftXSmall";
      }
      return css;
    },
  },
};
</script>
